module.exports = __webpack_public_path__ + "static/media/12a.513ae1b4.jpg";